export function useSearchResultsRandomizer() {
  const randomizeHighlightedResults = <T extends { highlight?: boolean }>(items: T[]): T[] => {
    const highlightedItems: T[] = []
    let firstNonHighlightedIndex = -1

    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      if (item.highlight === true) {
        highlightedItems.push(item)
      } else {
        firstNonHighlightedIndex = i
        break
      }
    }

    for (let i = highlightedItems.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[highlightedItems[i], highlightedItems[j]] = [highlightedItems[j], highlightedItems[i]]
    }

    return firstNonHighlightedIndex === -1
      ? highlightedItems
      : [...highlightedItems, ...items.slice(firstNonHighlightedIndex)]
  }

  // Shuffling must not happen during SSR: the HTML and the extracted
  // _payload.js are produced by separate renders (and cached separately by
  // Cloudflare), so a server-side shuffle hydrates one order over another and
  // leaves cards labelled with the wrong bank. The server renders the search
  // order; the highlighted items are shuffled in the browser once mounted.
  const shuffleHighlightedAfterMount = <T extends { highlight?: boolean }>(
    source: () => T[]
  ): ComputedRef<T[]> => {
    const isMounted = ref(false)

    onMounted(() => {
      isMounted.value = true
    })

    return computed(() => (isMounted.value ? randomizeHighlightedResults(source()) : source()))
  }

  return {
    randomizeHighlightedResults,
    shuffleHighlightedAfterMount
  }
}
